import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manga';

export default function CategorySection() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-2">按题材探索你喜欢的韩漫类型</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 bg-background-100 hover:bg-primary-50 rounded-xl transition-all"
            >
              <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-background-50 rounded-xl group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl text-primary-500`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">{cat.name}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}